import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Gift } from 'lucide-react';
const bonos = [{
  num: '01',
  color: 'green',
  value: '$5.990',
  title: 'Checklist Express de Ferretería',
  desc: '10 preguntas clave + hoja imprimible para ir al corralón sin errores.'
}, {
  num: '02',
  color: 'blue',
  value: '$4.990',
  title: 'Inspección Visual por Ambiente',
  desc: 'Recorré tu casa con la Tabla de Patrones Visuales que descifra cada señal.'
}, {
  num: '03',
  color: 'orange',
  value: '$3.990',
  title: 'Mini Manual de Errores Tontos',
  desc: 'Los 10 errores que arruinan resultados. 20 min de lectura, $187.000 ARS ahorrados.'
}];
const colorMap: Record<string, {
  text: string;
  border: string;
}> = {
  green: {
    text: 'text-green-500',
    border: 'border-t-green-500'
  },
  blue: {
    text: 'text-blue-500',
    border: 'border-t-blue-500'
  },
  orange: {
    text: 'text-orange-500',
    border: 'border-t-orange-500'
  }
};
export function BonusSection() {
  return <section className="py-8 md:py-12 px-4 bg-slate-900 border-y border-slate-800/50" data-id="element-21">
      <div className="max-w-3xl mx-auto" data-id="element-22">
        <FadeIn className="text-center mb-6" data-id="element-23">
          <Gift className="w-8 h-8 text-orange-500 mx-auto mb-2" strokeWidth={2} data-id="element-24" />
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-white tracking-wide mb-1" data-id="element-25">
            🎁 3 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-orange-500 font-bold tracking-widest uppercase text-xs" data-id="element-26">
            SIEMPRE INCLUIDOS
          </p>
        </FadeIn>

        <div className="space-y-4" data-id="element-27">
          {bonos.map((bono, i) => {
          const c = colorMap[bono.color];
          return <FadeIn key={bono.num} delay={0.1 + i * 0.1} data-id="element-28">
                <div className={`bg-slate-950 border border-slate-800 border-t-4 ${c.border} rounded-b-xl p-5 shadow-md`} data-id="element-29">
                  <div className="flex items-center justify-between gap-3 mb-2" data-id="element-30">
                    <p className="text-white font-bold text-sm flex items-center gap-2" data-id="element-31">
                      <span className={c.text} data-id="element-32">{bono.num}</span> 🎁 BONO{' '}
                      {bono.num.replace('0', '')}
                    </p>
                    <span className={`${c.text} font-bold text-sm`} data-id="element-33">
                      <span className="text-slate-500 line-through font-normal mr-1.5" data-id="element-34">
                        {bono.value}
                      </span>
                      GRATIS
                    </span>
                  </div>
                  <h3 className={`text-lg md:text-xl font-bold ${c.text} mb-2`} data-id="element-35">
                    {bono.title}
                  </h3>
                  <p className="text-slate-400 text-sm md:text-base leading-snug" data-id="element-36">
                    {bono.desc}
                  </p>
                </div>
              </FadeIn>;
        })}
        </div>

        <FadeIn delay={0.5} data-id="element-37">
          <div className="mt-6 text-center bg-orange-500/10 border border-orange-500/30 rounded-2xl p-4" data-id="element-38">
            <p className="text-base md:text-lg text-white" data-id="element-39">
              Valor total:{' '}
              <span className="text-slate-400 line-through mx-1" data-id="element-40">
                $14.970 ARS
              </span>{' '}
              <span className="text-orange-500 font-bold" data-id="element-41">→ GRATIS</span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}